<template>
  <div class="winner-info-item flex-grow-1 d-flex flex-column">
    <div class="my-8 my-sm-6 flex-grow-1 d-flex flex-column align-center justify-center">
      <div
        class="bg-white rounded"
        :class="{ 'pa-1': isLpus, 'winner-info-item__img_outlined': !isGrandPrixPage }"
      >
        <v-img
          class="mx-auto rounded"
          :width="imgWidth"
          :height="imgHeight"
          :src="src"
          :alt="imgAlt"
          cover
          @error="onError"
        />
      </div>

      <div class="mt-6 text-center d-flex flex-column">
        <a
          class="text-body-1 text-primary text-decoration-none"
          target="_blank"
          :href="link"
        >
          <slot name="winner-name" />
        </a>

        <div
          class="text-h5 d-flex align-center justify-center"
          :class="isGrandPrixPage ? 'order-3 mt-2' : 'mt-3'"
        >
          <slot name="winner-place" />
        </div>

        <div
          class="mt-2"
          :class="{'order-2': isGrandPrixPage}"
        >
          <span class="text-ui-kit-text-secondary text-body-2">
            <slot name="winner-location" />
          </span>
        </div>
      </div>
    </div>

    <v-sheet
      color="bg-white"
      class="winner-info-item__actions-list"
    >
      <v-divider />

      <div class="my-2">
        <v-hover v-slot="{ isHovering, props: hoverProps }">
          <div
            v-bind="hoverProps"
            class="cursor-pointer d-flex px-4 py-3"
            @click="emit('click:copy')"
          >
            <v-icon
              class="mr-8"
              icon="ui-icon-copy"
              :color="isHovering ? 'primary' : 'ui-kit-icon-secondary'"
            />
            <span :class="{'text-primary': isHovering}">
              {{ copyText }}
            </span>
          </div>
        </v-hover>
        <v-hover v-slot="{ isHovering, props: hoverProps }">
          <a
            v-bind="hoverProps"
            class="text-decoration-none"
            :class="isHovering ? 'text-primary' : 'text-ui-kit-text'"
            :href="certificateFullPath"
            download
          >
            <div class="cursor-pointer d-flex px-4 py-3">

              <v-icon
                class="mr-8"
                icon="ui-icon-download"
                :color="isHovering ? 'primary' : 'ui-kit-icon-secondary'"
              />
              <span>
                {{ downloadText }}
              </span>
            </div>
          </a>
        </v-hover>
      </div>
    </v-sheet>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
  imgSrc: { type: String as PropType<string | null>, default: null },
  imgWidth: { type: [Number, String], default: 150 },
  imgHeight: { type: [Number, String], default: 200 },
  imgAlt: { type: String, default: '' },
  pdLink: { type: String, required: true },
  placeholder: { type: String, default: '' },
  copyText: { type: String, default: 'Скопировать ссылку' },
  downloadText: { type: String, default: 'Скачать грамоту' },
  certificateUrl: { type: String, default: '' },
  isLpu: { type: Boolean, default: false },
})

const emit = defineEmits(['click:copy'])

const certificateFullPath = ref('')
const error = ref(false)

const $route = useRoute()
const $config = useRuntimeConfig().public
const { isGrandPrixPage } = usePageType()

const isLpus = computed(() => /lpus/.test($route.fullPath))

const src = computed(() => !props.imgSrc || error.value
  ? props.placeholder
  : `${$config.awardUrl}${props.imgSrc}`)

const link = computed(() => `${$config.pdUrl}${props.pdLink}`)

onBeforeMount(() => {
  const urlPrefix = '/media/'
  certificateFullPath.value = urlPrefix + props.certificateUrl
})

function onError() {
  error.value = true
}
</script>

<style lang="scss" scoped>
.winner-info-item {
  &__img_outlined {
    border: 1px solid $t-ui-kit-bg-gray-60;
  }

  &__actions-list {
    position: sticky;
    bottom: 0;
  }
}
</style>
